module.exports = __webpack_public_path__ + "static/media/400005_01.2470891e.png";